import { getAxiosInstanceApi } from "./api";
import { cachiosInstance } from "./cacheApi";

/**
 * ----------------------------
 *  Setting routes
 * ----------------------------
 */

export const getSetting = (callback, force = false) => {
    cachiosInstance.get(`/setting`, { force })
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const updateSetting = (name, query, callback) => {
    getAxiosInstanceApi().put(`/setting/${name}?${query}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
